import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Link, useSearchParams } from 'react-router'
import { api } from '../api/client.js'
import { money } from '../lib/money.js'

/** After Stripe Checkout. The webhook can lag a few seconds: poll briefly. */
export default function ThanksPage() {
  const { t, i18n } = useTranslation()
  const [params] = useSearchParams()
  const id = params.get('donation')
  const [d, setD] = useState(null)

  useEffect(() => {
    if (!id) return
    let tries = 0
    let stop = false
    const tick = async () => {
      try {
        const s = await api.donationStatus(id)
        if (stop) return
        setD(s)
        if (s.status === 'pending' && ++tries < 10) setTimeout(tick, 2000)
      } catch {
        // keep the generic thank-you
      }
    }
    tick()
    return () => {
      stop = true
    }
  }, [id])

  const paid = d?.status === 'paid'
  return (
    <main className="mx-auto flex max-w-xl flex-col items-center gap-4 px-4 py-24 text-center sm:px-8">
      <span className="text-6xl">{paid ? '💚' : '⏳'}</span>
      <h1 className="text-3xl font-black">{t('donate.thanksTitle')}</h1>
      <p className="text-lg text-muted">
        {paid
          ? t(d.kind === 'monthly' ? 'donate.thanksMonthly' : 'donate.thanksMeals', {
              count: d.meals,
              amount: money(d.amount_cents, d.currency, i18n.resolvedLanguage),
            })
          : t('donate.processing')}
      </p>
      <div className="flex flex-wrap justify-center gap-3">
        <Link to="/live" className="rounded-full bg-teal px-6 py-3 font-extrabold text-on-teal no-underline">{t('nav.watchLive')}</Link>
        <Link to="/transparency" className="rounded-full border-[1.5px] border-edge px-6 py-3 font-extrabold text-ink no-underline">{t('donate.transparency')}</Link>
      </div>
    </main>
  )
}
